// useDebounce — defer a rapidly-changing value until it has been stable for
// `delayMs` consecutive milliseconds. Used by the support-list search input
// to avoid hammering the Edge Function with one request per keystroke.
//
// Pattern follows the canonical React hook (Dan Abramov's blog post + the
// `usehooks.com` reference). We keep it in-tree instead of pulling a 4kb
// package because it's 12 lines of code and we don't want a transitive dep
// surface for something this small.

import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => {
      clearTimeout(id);
    };
  }, [value, delayMs]);
  return debounced;
}
